bovoApp.controller('MarketplaceIntegrationController', ['$scope', '$http', 'Marketplace',
    function ($scope, $http, Marketplace) {
        // ============ STATE ============
        $scope.f = { provider: 'all', status: 'all', term: '' };
        $scope.data = { data: [], total: 0, current_page: 1, last_page: 1 };
        $scope.providers = [];
        $scope.selectedProvider = null; // form icin secilen provider metadata
        $scope.integration = null;      // form icin acik integration
        $scope.formCreds = {};          // duz credential input
        $scope.testResult = null;
        $scope.loading = false;
        $scope.busyId = null;           // aksiyon calisirken butonlar spinner

        // ============ LOAD ============
        $scope.loadProviders = function () {
            Marketplace.providers().success(function (res) {
                $scope.providers = res.data || [];
            });
        };

        $scope.load = function (page) {
            var params = angular.copy($scope.f);
            if (page) params.page = page;
            $scope.loading = true;
            Marketplace.integrations(params).success(function (res) {
                $scope.data = res;
                $scope.loading = false;
            }).error(function () {
                $scope.loading = false;
            });
        };

        $scope.goToPage = function (page) {
            $scope.load(page);
        };

        // ============ CREATE/EDIT ============
        $scope.newIntegration = function () {
            $scope.integration = {
                provider: '',
                company_customer_id: null,
                store_id: '',
                store_name: '',
                status: 'active',
                pull_interval_minutes: 240,
                sync_interval_minutes: 120,
                days_back: 3,
                notes: ''
            };
            $scope.selectedProvider = null;
            $scope.formCreds = {};
            $scope.testResult = null;
            $('#integrationModal').modal('show');
        };

        $scope.editIntegration = function (item) {
            $scope.integration = angular.copy(item);
            $scope.selectedProvider = findProvider(item.provider);
            // Edit'te credential maskeli gelir — kullanici degistirmek istemiyorsa bos birakir
            $scope.formCreds = {};
            $scope.testResult = null;
            $('#integrationModal').modal('show');
        };

        $scope.onProviderChange = function () {
            $scope.selectedProvider = findProvider($scope.integration.provider);
            // Default degerleri doldur
            if ($scope.selectedProvider && $scope.selectedProvider.fields) {
                angular.forEach($scope.selectedProvider.fields, function (f) {
                    if (f.default && !$scope.formCreds[f.key]) {
                        $scope.formCreds[f.key] = f.default;
                    }
                });
            }
        };

        $scope.saveIntegration = function () {
            var payload = angular.copy($scope.integration);

            // Credential yalnizca doldurulmus alanlari gonderelim (partial update)
            var creds = {};
            var hasAny = false;
            angular.forEach($scope.formCreds, function (v, k) {
                if (v !== null && v !== undefined && v !== '') {
                    creds[k] = v;
                    hasAny = true;
                }
            });
            if (hasAny) {
                payload.credentials = creds;
            } else if (!$scope.integration.id) {
                Messenger().post({ message: 'Credential alanlari zorunlu', type: 'error' });
                return;
            }

            var req = $scope.integration.id
                ? Marketplace.updateIntegration($scope.integration.id, payload)
                : Marketplace.saveIntegration(payload);

            req.success(function (res) {
                Messenger().post(res.message || 'Kaydedildi');
                $('#integrationModal').modal('hide');
                $scope.load($scope.data.current_page);
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Kaydedilemedi', type: 'error' });
            });
        };

        // ============ DELETE ============
        $scope.confirmDelete = function (item) {
            $scope.integration = item;
            $scope.deleteTarget = item.id;
            $('#delete').modal('show');
        };

        $scope.delete = function (type) {
            if (type !== 'delete') return;
            Marketplace.deleteIntegration($scope.deleteTarget).success(function (res) {
                Messenger().post(res.message || 'Silindi');
                $('#delete').modal('hide');
                $scope.load($scope.data.current_page);
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Silinemedi', type: 'error' });
            });
        };

        // ============ TEST ============
        $scope.testConnection = function (item) {
            var id = item ? item.id : ($scope.integration && $scope.integration.id);
            if (!id) {
                Messenger().post({ message: 'Once kaydedin, sonra test edin', type: 'error' });
                return;
            }
            $scope.busyId = id;
            $scope.testResult = null;
            Marketplace.testIntegration(id).success(function (res) {
                $scope.testResult = res;
                $scope.busyId = null;
                Messenger().post({
                    message: res.message,
                    type: res.success ? 'success' : 'error'
                });
            }).error(function (res) {
                $scope.busyId = null;
                Messenger().post({ message: (res && res.message) || 'Test hatasi', type: 'error' });
            });
        };

        // ============ TRIGGER ============
        $scope.triggerAction = function (item, action) {
            var fn;
            if (action === 'pull') fn = Marketplace.triggerPull;
            else if (action === 'sync') fn = Marketplace.triggerSync;
            else if (action === 'claims') fn = Marketplace.triggerClaims;
            else return;

            $scope.busyId = item.id + '_' + action;
            fn(item.id).success(function (res) {
                $scope.busyId = null;
                Messenger().post(res.message || 'Tetiklendi');
            }).error(function (res) {
                $scope.busyId = null;
                Messenger().post({ message: (res && res.message) || 'Tetiklenemedi', type: 'error' });
            });
        };

        // ============ HELPERS ============
        function findProvider(key) {
            for (var i = 0; i < $scope.providers.length; i++) {
                if ($scope.providers[i].key === key) return $scope.providers[i];
            }
            return null;
        }

        $scope.providerLabel = function (key) {
            var p = findProvider(key);
            return p ? p.label : key;
        };

        $scope.statusLabel = function (s) {
            switch (s) {
                case 'active':   return 'Aktif';
                case 'inactive': return 'Pasif';
                case 'error':    return 'Hatali';
                default:         return s;
            }
        };

        // Init
        $scope.init = function () {
            $scope.loadProviders();
            $scope.load();
        };
    }
]);
